import { User, JwtConfigs } from "@/store/authentication/types";
import { SSODtoIn, AzureAdConfig } from "@/services/security/types";
import api from "../api";
import store from "@/store/index";
import * as Msal from "msal";
import { loginRequest, msalConfig } from "@/services/security/azureConfigs";
import router from "@/router";

export async function getAzureAdConfig(): Promise<AzureAdConfig> {
    return new Promise((resolve, reject) => {
        api.get("/account/azureAdConfig").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function login(user: User): Promise<any> {
    return new Promise((resolve, reject) => {
        api.post("/account/login/", user).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function azureLogin(): Promise<any> {
    const appSettings = await getAzureAdConfig();
    msalConfig.auth.clientId = appSettings.azureAppClientId;
    msalConfig.auth.redirectUri = appSettings.redirectUri;
    msalConfig.auth.authority = `https://login.microsoftonline.com/${appSettings.vscTenantId}`;
    const MsalObj = new Msal.UserAgentApplication(msalConfig);
    return new Promise((resolve, reject) => {
        MsalObj.loginPopup(loginRequest).then(loginResponse => {
            api.post("/account/AzureLogIn/", { token: loginResponse.idToken.rawIdToken } as SSODtoIn).then(
                response => {
                    resolve(response);
                },
                error => {
                    reject(error);
                }
            );
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

export async function azureLogout() {
    const appSettings = await getAzureAdConfig();
    msalConfig.auth.clientId = appSettings.azureAppClientId;
    msalConfig.auth.redirectUri = appSettings.redirectUri;
    const MsalObj = new Msal.UserAgentApplication(msalConfig);
    MsalObj.logout();
};

export async function getToken(): Promise<any> {
    const appSettings = await getAzureAdConfig();
    msalConfig.auth.clientId = appSettings.azureAppClientId;
    msalConfig.auth.redirectUri = appSettings.redirectUri;
    const MsalObj = new Msal.UserAgentApplication(msalConfig);
    // if (myMSALObj.getAccount()) {
    //     showWelcomeMessage(myMSALObj.getAccount());
    // }
    return MsalObj.acquireTokenSilent(loginRequest)
        .then((response) => {
            console.log(response);
            if (response.accessToken) {
                console.log("access_token acquired at: " + new Date().toString());
                const accessToken = response.accessToken;
                console.log("silent");
                console.log(accessToken);
            }
        }).catch(error => {
            console.log("silent token acquisition fails. acquiring token using redirect");
            console.log(error);
            // fallback to interaction when silent call fails
            return MsalObj.acquireTokenRedirect(loginRequest);
        });
};

export function logout() {
    store.commit("authentication/authClear");
}

export async function checkIfAuthenticated(): Promise<any> {
    return new Promise((resolve, reject) => {
        api.get("/account/isAuthenticated").then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}

let time = 0;
export function configAutoLogout() {
    store.commit("authentication/setAutoLogout", false);
    const jwtConfigs: JwtConfigs = store.getters["authentication/getJwtConfigs"];
    const notificationTimeInSeconds = jwtConfigs.jwtExpireSeconds + jwtConfigs.jwtInvalidSeconds - jwtConfigs.jwtLogoutWarningSeconds;
    resetTime();
    if (notificationTimeInSeconds > 0) {
        startAutoLogout(notificationTimeInSeconds);
    }
}

function resetTime() {
    clearTimeout(time);
}

function startAutoLogout(seconds: number) {
    time = setTimeout(logoutNotification, seconds * 1000);
}

function logoutNotification() {
    store.commit("authentication/setAutoLogout", true);
    resetTime();
    time = setTimeout(goToLogin, store.getters["authentication/getJwtConfigs"].jwtLogoutWarningSeconds * 1000);
}

function goToLogin() {
    logout();
    router.push("/login");
}
